export default "__VITE_ASSET__DoAT_Mvw__"